export default {
  currentUser: {
    id: '',
    userType: '',
    name: '',
    email: ''
  }
}
